/** Character limits aligned with backend {@code InputLimits}. */
export const inputLimits = {
  comprehensionAnswer: 2000,
  comprehensionQuestion: 500,
  personalNotes: 500,
  translation: 200,
  shortText: 500,
  contextSentence: 500,
  aiMessage: 4000,
} as const

const sqlInjectionPattern =
  /(?:;\s*(?:drop|delete|truncate|alter|create|insert|update|select)\b|union\s+(?:all\s+)?select\b|(['"])\s*;\s*|'\s*or\s+(['"]?)\s*\d+\s*'\s*=\s*'\s*\d+|--\s|\/\*|\*\/|information_schema\b|xp_\w+|\bexec\s*\(|\u0000)/i

export function containsSuspiciousText(value: string): boolean {
  return sqlInjectionPattern.test(value)
}

export function trimToLimit(value: string, max: number): string {
  return value.length > max ? value.slice(0, max) : value
}
